import React from 'react';
import {
  AreaInput,
  ISelectOption,
  ISpruceFieldProps,
  PhoneNumberInput,
  Select,
  SpruceField,
  TextInput,
} from 'ui-toolkit';
import { activeClientContactsFunctionsOptions } from '../../types/contacts/activeClientContactsFunctionsOptions';
import { useListContactFunctionsQuery } from '../../API/contacts/ContactFunctionsApi';
import { getContactFunctionValue } from '../../utilities/contact/getContactFunctionValue';

interface IClientContactFormProps {
  disableNotEditableFields: boolean;
  onAddContact?: (email: string) => void;
}

export const ClientContactForm: React.FC<IClientContactFormProps> = ({ disableNotEditableFields, onAddContact }) => {
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();
  return (
    <>
      <SpruceField name={'firstName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'First Name'} isRequired />}
      </SpruceField>
      <SpruceField name={'middleName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Middle Name'} />}
      </SpruceField>
      <SpruceField name={'lastName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Last Name'} isRequired />}
      </SpruceField>
      <SpruceField name={'companyName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Company Name'} />}
      </SpruceField>
      <SpruceField name={'email'}>
        {({ field }: ISpruceFieldProps) => (
          <TextInput
            {...field}
            label={'Email'}
            onBlur={() => onAddContact && onAddContact(field.value)}
            readOnly={disableNotEditableFields}
            isRequired
          />
        )}
      </SpruceField>
      <SpruceField name={'phoneNumber'}>
        {({ field }: ISpruceFieldProps) => <PhoneNumberInput {...field} label={'Phone Number'} />}
      </SpruceField>
      <SpruceField name={'functions'}>
        {({ field }: ISpruceFieldProps) => (
          <Select
            {...field}
            onChange={(values: ISelectOption[]) => field.onChange(values.map((value) => value.value))}
            value={getContactFunctionValue(field.value, contactFunctions)}
            options={activeClientContactsFunctionsOptions(contactFunctions)}
            isClearable
            isMulti
            label={'Function(s)'}
          />
        )}
      </SpruceField>
      <SpruceField name={'notes'}>
        {({ field }: ISpruceFieldProps) => (
          <AreaInput
            {...field}
            rows={2}
            onBlur={() => field.onChange(field.value ? field.value.trim() : field.value)}
            label={'Notes'}
            placeholder={'Notes...'}
          />
        )}
      </SpruceField>
    </>
  );
};
